module.exports = __webpack_public_path__ + "img/max-file-content-image-edit.858c511a.svg";